<template>
  <v-layout>
    <v-flex>
      <v-layout align-baseline>
        <v-flex>
          <h1 class="headline">{{ editLabel }}</h1>
        </v-flex>
        <v-flex>
          <v-layout justify-end pa-3>
            <one-page-view-switch
              setting-name="clientOnePageView"
              v-model="onePage"
            />
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout v-if="onePage" fluid>
        <v-expansion-panels v-model="panels" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <h5 class="headline">Details</h5>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <client-editor-details
                :client="updatedClient"
                :loading="loading"
                @onSave="saveClient"
                @onChange="onChangeClient($event)"
              ></client-editor-details>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel :disabled="disabled">
            <v-expansion-panel-header>
              <h5 class="headline">Custom Fields</h5>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <custom-fields-form
                v-model="updatedClient.customFields"
                :show-title="false"
                @onSave="saveClient"
              ></custom-fields-form>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <h5 class="headline">Itineraries</h5>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <itinerary-list
                :cached-filters="false"
                :custom-filters="itinerariesFilter"
                :show-title="false"
                ref-name="clientItineraryList"
              ></itinerary-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel
            v-if="this.$store.getters.hasAccessTo('plugins:task_tracker')"
          >
            <v-expansion-panel-header>
              <h5 class="headline">Tasks</h5>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <task-tracker-list :client="updatedClient"></task-tracker-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <h5 class="headline">Emails</h5>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <emails-list :client-id="updatedClient.id" />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-layout>
      <v-layout v-else>
        <v-flex>
          <v-tabs
            background-color="transparent"
            class="elevation-2 gradient-bg"
            centered
            dark
          >
            <v-tab key="details" ripple>Details</v-tab>

            <v-tab-item key="details">
              <client-editor-details
                :client="updatedClient"
                :loading="loading"
                @onSave="saveClient"
                @onChange="onChangeClient($event)"
              ></client-editor-details>
            </v-tab-item>

            <v-tab key="customFields" ripple :disabled="disabled"
              >Custom Fields</v-tab
            >
            <v-tab-item key="customFields">
              <custom-fields-form
                v-model="updatedClient.customFields"
                @onSave="saveClient"
              ></custom-fields-form>
            </v-tab-item>
            <v-tab key="itineraries" ripple :disabled="disabled"
              >Itineraries</v-tab
            >
            <v-tab-item key="itineraries">
              <v-container fluid>
                <itinerary-list
                  :cached-filters="false"
                  :custom-filters="itinerariesFilter"
                  ref-name="clientItineraryList"
                ></itinerary-list>
              </v-container>
            </v-tab-item>

            <v-tab
              key="tasks"
              ripple
              v-if="this.$store.getters.hasAccessTo('plugins:task_tracker')"
              >Tasks</v-tab
            >
            <v-tab-item key="tasks">
              <task-tracker-list :client="updatedClient"></task-tracker-list>
            </v-tab-item>
            <v-tab key="email" ripple>Emails</v-tab>
            <v-tab-item key="emails">
              <emails-list :client-id="updatedClient.id" />
            </v-tab-item>
          </v-tabs>
        </v-flex>
      </v-layout>
      <v-layout>
        <back-to-list-btn route="/clients" v-if="!isModal"></back-to-list-btn>
      </v-layout>
      <div v-if="debug">
        <code>{{ updatedClient.customFields }}</code>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import {
  CLIENT_RECORD_QUERY,
  CLIENT_UPDATE_MUTATION,
  CLIENT_CREATE_MUTATION,
} from "../../../constants/graphql";
import CustomFieldsForm from "../shared/CustomFieldsForm";
import ClientEditorDetails from "./ClientEditorDetails";
import BackToListBtn from "../shared/BackToListBtn";
import OnePageViewSwitch from "../shared/OnePageViewSwitch";
import UnsavedChangesGuard from "../../../mixins/UnsavedChangesGuard";
import ItineraryList from "../itineraries/ItineraryList";
import TaskTrackerList from "../plugins/task-tracker/TaskTrackerList";

import EmailsList from "../shared/EmailsList.vue";
export default {
  name: "ClientEditor",
  props: {
    clientId: {
      type: String,
      default: () => "",
    },
    isModal: {
      type: Boolean,
      dafault: () => false,
    },
  },
  components: {
    ClientEditorDetails,
    CustomFieldsForm,
    BackToListBtn,
    OnePageViewSwitch,
    ItineraryList,
    TaskTrackerList,
    EmailsList,
  },

  mixins: [UnsavedChangesGuard],

  data() {
    return {
      debug: false,
      onePage: false,
      panels: [0],
      items: 5,
      id: this.clientId != "" ? this.clientId : this.$route.params.id,
      skipLoad: true,
      updatedClient: {
        title: "",
      },
      loading: false,
    };
  },

  watch: {
    clientId(newClientId) {
      this.id = newClientId;
    },
  },

  computed: {
    itinerariesFilter() {
      return this.client
        ? {
            clientId_eq: this.client.id,
          }
        : {};
    },
    editLabel: function () {
      return this.updatedClient.name
        ? `${this.updatedClient.title} ${this.updatedClient.name} ${this.updatedClient.surname}`
        : "New Client";
    },
    disabled: function () {
      return this.updatedClient.id ? false : true;
    },
  },

  methods: {
    backToList() {
      this.$router.go(-1);
    },
    onChangeClient(client) {
      this.updatedClient = client;
    },
    saveClient() {
      this.loading = true;
      //console.log("this.updatedClient", this.updatedClient);
      const mutation = this.id
        ? CLIENT_UPDATE_MUTATION
        : CLIENT_CREATE_MUTATION;
      const { ...vars } = this.updatedClient;
      if (this.id) {
        vars.id = this.id;
      }
      this.$apollo
        .mutate({
          mutation: mutation,
          variables: vars,
        })
        .then(this.saveClientHandler, this.saveClientErrorHandler);
    },

    saveClientHandler(result) {
      //console.log("this.saveClientHandler", result.data.updateClient );
      this.loading = false;
      if (result.data.hasOwnProperty("createClient")) {
        this.id = result.data.createClient.id;
        this.$router.push("/client/" + this.id + "/edit");
        this.$store.dispatch("showAppSnackbar", { msg: "Client Saved." });
      } else {
        this.$store.dispatch("showAppSnackbar", { msg: "Client Updated." });
        this.$emit("saved", { ...result.data.updateClient });
      }
      this.storeInitState();
    },

    saveClientErrorHandler(err) {
      this.loading = false;
      const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
      this.$store.dispatch("showAppSnackbar", {
        msg: errorMsg,
        color: "error",
      });
    },

    onCustomFieldsChange(data) {
      //console.log("updated: ", data);
      this.updatedClient.customFields = data;
    },
  },

  apollo: {
    client: {
      query: CLIENT_RECORD_QUERY,
      variables() {
        return {
          id: this.id,
        };
      },
      result({ data, loader, networkStatus }) {
        if (data.client) {
          const { customFields, ...client } = data.client;
          this.updatedClient = {
            ...client,
            customFields: customFields.edges.map((i) => ({
              name: i.node.name,
              content: i.node.content,
              typeId: i.node.typeId,
            })),
          };
        }
        this.storeInitState();
      },
      skip() {
        return this.id == undefined || this.skipLoad;
      },

      fetchPolicy: "network-only",
    },
  },
  mounted() {
    this.skipLoad = false;
  },
};
</script>

<style scoped>
.gradient-bg {
  background: linear-gradient(to right top, #4527a0, #9575cd);
}
</style>



// WEBPACK FOOTER //
// src/components/gt/clients/ClientEditor.vue